import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../redux/store";
import { selectProductDetails } from "../../../routes/pdp/selectors";
import { isTouchScreen } from "../../../util";
import {
  selectCdnImageSettings,
  selectSyteSettings
} from "../../../util/selectors";
import SyteDiscoveryButton from "../syteButton/syteDiscoveryButton";

export const SyteSearchSimilarItemsButton = () => {
  const { t } = useTranslation("productDetails");

  const [sytePortalRoot, setSytePortalRoot] = useState(null);

  const item = useAppSelector(selectProductDetails);
  const configCdnImagesSettings = useAppSelector(selectCdnImageSettings);
  const configSyteSettings = useAppSelector(selectSyteSettings);

  const isDiscoveryButtonEnabled = configSyteSettings?.enableDiscoveryIcon;

  const syteButton = (
    <SyteDiscoveryButton
      sku={item.id}
      productImgPath={`${configCdnImagesSettings?.main}${item?.captionImageURL}`}
      placement="pdp-swiper"
      mobile
      text={t("viewSimilarStyles")}
      //TODO: add click handler for Analytic
      handleClick={undefined}
      details={item}
    />
  );

  const handlePortalWrapping = (component, portalRoot) =>
    isTouchScreen() && portalRoot
      ? ReactDOM.createPortal(component, portalRoot)
      : component;

  useEffect(() => {
    setSytePortalRoot(document.getElementById("item-preview"));
  }, []);

  const renderSyteButton =
    (isDiscoveryButtonEnabled &&
      handlePortalWrapping(syteButton, sytePortalRoot)) ||
    null;

  return renderSyteButton;
};
